import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../../routes/paths";
import { MoreAboutCompanyFormData } from "./config";

export function handleMoreAboutCompanySuccess(
  navigate: NavigateFunction
): void {
  navigate(ROUTE_PATHS.MY_PROFILE);
}

export function getCreateProfilePayload(
  data: MoreAboutCompanyFormData,
  defaultNoOfEmp: string | number
): {
  company: string;
  title?: string;
  linkedIn?: string;
  no_of_emp: string | number;
} {
  return {
    company: data.company,
    ...(data.title && { title: data.title }),
    ...(data.linkedIn && { linkedIn: data.linkedIn }),
    no_of_emp: data.no_of_emp || defaultNoOfEmp,
  };
}

export function getFinishProfileSetupPayload(
  email: string,
  companyName: string
): {
  email: string;
  name: string;
} {
  return {
    email,
    name: companyName,
  };
}
